module.exports = __webpack_public_path__ + "img/1.3d5511e6.png";